import React, { useState } from 'react';
import { Input, Button, Col, Row } from 'reactstrap';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab'
import { connect } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import CustomModal from '../../../components/modales/customModal';
import {
    useNavigate
} from "react-router-dom";

const mapStateToProps = state => ({
    usuarioActivo: state
})

const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const AddAuxilio = (props) => {

    return (
        <Col lg='6' md='6' xs="12">
            <Row>
                <Col lg='6' md='6' xs="12">
                    <Autocomplete
                        required
                        variant='outlined'
                        margin="dense"
                        options={[
                            { id: "auxAlimentacion", name: "Auxilio de Alimentación" },
                            { id: "auxLocalizacion", name: "Auxilio de Localización" },
                            { id: "auxMovilizacion", name: "Auxilio de Movilización" },
                            { id: "jornadaSuplementaria", name: "Jornada Suplementaria" }
                        ]}
                        key={`key_TipoDeContrato`}
                        id={`select_TipoDeContrato`}
                        onChange={(event, newValue) => console.log(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label={'Auxilio'} margin="normal" />
                        )}
                        getOptionLabel={(option) => option.name}
                        renderOption={(option) => (
                            <React.Fragment>
                                {option.name}
                            </React.Fragment>
                        )}
                    />
                </Col>
                <Col lg='6' md='6' xs="12">
                    <Button onClick={() => { console.log('click') }}>
                        Agregar
                    </Button>
                </Col>
            </Row>
        </Col>
    );
}

export default connect(mapStateToProps)(AddAuxilio);